<template>
  <bimPopup title="" width="auto" :value="value" @input="emitClose">
    <div class="download-popup">
      <transition mode="out-in" name="download-popup">
        <SlideLoading v-if="currentSlide === SLIDES.LOADING" key="loading" />
        <SlideStartDownload
          v-if="currentSlide === SLIDES.START_DOWNLOAD"
          key="start_download"
          @closePopup="emitClose"
        />
        <SlideFoundPositions
          v-if="currentSlide === SLIDES.FOUND_POSITIONS"
          key="found_positions"
          :positions="positions"
          @downloadExample="downloadExample"
          @downloadFull="downloadFull"
        />
        <SlideStartDownloadExample
          v-if="currentSlide === SLIDES.START_DOWNLOAD_EXAMPLE"
          key="start_download_positions"
          :positions="positions"
          @closePopup="emitClose"
          @downloadFull="downloadFull"
        />
        <SendRequest
          v-if="currentSlide === SLIDES.SEND_REQUEST"
          key="send_request"
          :form_type="1"
          class="send-request-slide"
        />
      </transition>
    </div>
  </bimPopup>
</template>

<script>
import bimPopup from "@bimlib/components/bimPopup"

import SlideLoading from "./SlideLoading"
import SlideStartDownload from "./SlideStartDownload"
import SlideFoundPositions from "./SlideFoundPositions"
import SlideStartDownloadExample from "./SlideStartDownloadExample"

import SendRequest from "@/pages/forms/Send_request"

import { logevent } from "@/utils/logEvents"
import Config from "@/config"

const localStoragePrefix = "download_popup"
const localStoragePrefixState = localStoragePrefix + "_state"
const localStoragePrefixShow = localStoragePrefix + "_show"
const localStoragePrefixSecond = localStoragePrefix + "_second"

function getItem(name) {
  return sessionStorage.getItem(name)
}
function saveItem(name, value) {
  return sessionStorage.setItem(name, value)
}
function removeItem(name) {
  return sessionStorage.removeItem(name)
}
export default {
  name: "DownloadPopup",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    file: {
      type: File,
      default: "",
    },
  },
  components: {
    bimPopup,

    SlideLoading,
    SlideStartDownload,
    SlideFoundPositions,
    SlideStartDownloadExample,

    SendRequest,
  },
  data() {
    return {
      isAuthorized: false,
      SLIDES: {
        LOADING: 0,
        START_DOWNLOAD: 1,
        FOUND_POSITIONS: 2,
        START_DOWNLOAD_EXAMPLE: 3,
        SEND_REQUEST: 4,
      },
      currentSlide: 0,
      /**
       * positions_count: Number,
       * positions_price: Number,
       * link_download_full: String,
       * link_download_example: String,
       * positions: Array
       */
      positions: [],
      lastCalledFunction: "",
    }
  },
  watch: {
    value(val) {
      // Первое открытие попапа
      if (val && this.currentSlide === 0) {
        logevent({ filename: this.file.name }, "SEND_FILE_KKA")

        const form = new FormData()
        form.append('file', this.file)
        axios
          .post('/api-estimate/cost-estimate', form)
          .then(res => {
            logevent({ filename: this.file.name }, "SUCCESS_FILE_PROCESS")
            this.currentSlide = this.SLIDES.FOUND_POSITIONS
            this.positions = res.data
          })
          .catch(err => {
            this.emitClose()
            this.$toast('Произошла ошибка, файл некорректный и не может быть обработан', { title: 'Ошибка' })
          })
      }
    }
  },
  async mounted() {
    const show = getItem(localStoragePrefixShow)
    if (show) {
      this.$emit('input', true)
      removeItem(localStoragePrefixShow)
      this.getState()
    }

    try {
      await this.$user.fetchContext()
      this.isAuthorized = true
    } catch(e) { }

    if (show) {
      this[this.lastCalledFunction]()
    }
  },
  methods: {
    downloadExample() {
      this.lastCalledFunction = "downloadExample"
      this.authorizedAction(
        () => {
          this.currentSlide = this.SLIDES.START_DOWNLOAD_EXAMPLE
          window.open(this.positions.link_download_example, '_blank')
        },
        this.SLIDES.START_DOWNLOAD_EXAMPLE,
      )
    },
    downloadFull() {
      this.lastCalledFunction = "downloadFull"
      this.authorizedAction(
        () => {
          this.currentSlide = this.SLIDES.SEND_REQUEST
        },
        this.SLIDES.SEND_REQUEST,
      )
    },
    authorizedAction(callback, slideAfterLogin=0) {
      if (this.isAuthorized) {
        callback()
      }
      else if (!getItem(localStoragePrefixSecond)) {
        saveItem(localStoragePrefixSecond, true)
        this.saveState()
        saveItem(localStoragePrefixShow, true)
        this.$user.openLoginPage('web', Config.appEnv)
      }
      else {
        removeItem(localStoragePrefixSecond)
      }
    },
    saveState() {
      const data = JSON.stringify(this.$data)
      saveItem(localStoragePrefixState, data)
    },
    getState() {
      const data = getItem(localStoragePrefixState)
      if (data) {
        this.replaceData(JSON.parse(data))
      }
      removeItem(localStoragePrefixState)
    },
    replaceData(obj, names=[]) {
      Object.assign(this.$data, obj)
    },
    emitClose() {
      this.currentSlide = 0
      this.$emit('input', false)
    },
  },
}
</script>

<style>
.download-popup-enter-active,
.download-popup-leave-active {
  transition: opacity .2s ease;
}
.download-popup-enter,
.download-popup-leave-to {
  opacity: 0;
}
.send-request-slide {
  width: 350px;
}
</style>
